/*** IMPORTS FROM imports-loader ***/

var define = false;

// Require the stlye files inside the "src/scss" folder.
require('SRC_STYLES/kmu.theme.scss');

// Require all static images inside the "src/images" folder.
require.context('SRC_IMAGES', true, /\.(gif|png|jpe?g|svg)$/);

require('./partials/lesson-dialog.js');
